import * as actionTypes from "./actionTypes";
import { debounce } from "lodash";

export const updateTriviaResponses = val => {
  return {
    type: actionTypes.UPDATE_TRIVIA_RESPOSNES,
    payload: val,
  };
};

export const setCurrentQuestion = val => {
  return {
    type: actionTypes.SET_CURRENT_QUESTION,
    payload: val,
  };
};
export const setCurrentQuizQuestion = val => {
  console.log("_______CORRECT_______");
  return {
    type: actionTypes.SET_CURRENT_QUIZ_QUESTION,
    payload: val,
  };
};

export const setAnswerType = val => {
  return {
    type: actionTypes.SET_ANSWER_TYPE,
    payload: val,
  };
};

export const completeTrivia = val => {
  return {
    type: actionTypes.COMPLETE_TRIVIA,
  };
};
export const resetTrivia = val => {
  return {
    type: actionTypes.RESET_TRIVIA,
  };
};
export const setCurrentTrivia = val => {
  return {
    type: actionTypes.SET_CURRENT_TRIVIA,
    payload: val,
  };
};
export const editCurrentTriviaQuestions = val => {
  return {
    type: actionTypes.EDIT_CURRENT_TRIVIA_QUESTIONS,
    payload: val,
  };
};
export const editCurrentTriviaWelcomeData = val => {
  return {
    type: actionTypes.EDIT_CURRENT_TRIVIA_WELCOME_DATA,
    payload: val,
  };
};
export const editCurrentTriviaEndingData = val => {
  return {
    type: actionTypes.EDIT_CURRENT_TRIVIA_ENDING_DATA,
    payload: val,
  };
};
export const editCurrentTriviaThemeData = val => {
  return {
    type: actionTypes.EDIT_CURRENT_TRIVIA_THEME_DATA,
    payload: val,
  };
};

export const setCurrentQuiz = val => {
  return {
    type: actionTypes.SET_CURRENT_QUIZ,
    payload: val,
  };
};

export const setCurrentQuizExternalUserdata = val => {
  return {
    type: actionTypes.SET_CURRENT_QUIZ_EXTERNAL_USER_DATA,
    payload: val,
  };
};

export const editCurrentTriviaShareData = val => {
  return {
    type: actionTypes.EDIT_CURRENT_TRIVIA_SHARE_DATA,
    payload: val,
  };
};

export const setCurrentQuizResultObjectId = val => {
  return {
    type: actionTypes.SET_CURRENT_QUIZ_RESULT_OBJECT_ID,
    payload: val,
  };
};
export const setCurrentQuizLinkedRewards = val => {
  return {
    type: actionTypes.SET_CURRENT_QUIZ_LINKED_REWARDS,
    payload: val,
  };
};

export const setResultTableColsMap = val => {
  return {
    type: actionTypes.SET_TRIVIA_RESULT_TABLE_COLS_MAP,
    payload: val,
  };
};
export const setImportTemplateAddedTrivvys = val => {
  return {
    type: actionTypes.SET_IMPORT_TEMPLATE_TRIVVYS,
    payload: val,
  };
};
export const setTrivvyRatingSubmitted = val => {
  return {
    type: actionTypes.SET_TRIVVY_RATING_SUBMITTED,
    payload: val,
  };
};

export const handleGlobalRewardModal = val => {
  return {
    type: actionTypes.OPEN_REAWRD_MODAL_GLOB,
    payload: val,
  };
};

export const updateSingleLibrarayStatsForTrivvyCount = val => {
  return {
    type: actionTypes.UPDATE_SINGLE_LIB_STATS_TRIVVY_COUNT,
    payload: val,
  };
};

export const updateSingleLibrarayStatsForQuestionsCount = val => {
  return {
    type: actionTypes.UPDATE_SINGLE_LIB_STATS_QUESTION_COUNT,
    payload: val,
  };
};

export const setCurrentTrivvyComments = val => {
  return {
    type: actionTypes.SET_CURRENT_TRIVVY_COMMENTS,
    payload: val,
  };
};

export const setCreateModalState = val => {
  return {
    type: actionTypes.SET_CREATE_MODAL_STATE,
    payload: val,
  };
};

export const setLibraryScheduleLoader=(val)=>{
  return {
    type: actionTypes.SET_LIBRARY_SCHEDULE_LOADER,
    payload: val,
  };
}
export const setCreateTrivvyLoader=(val)=>{
  return {
    type: actionTypes.SET_TRIVVY_CREATE_LOADER,
    payload: val,
  };
}
export const setCreateLibraryLoader=(val)=>{
  return {
    type: actionTypes.SET_LIBRARY_CREATE_LOADER,
    payload: val,
  };
}
export const setGenerateSummaryLoader=(val)=>{
  return {
    type: actionTypes.SET_SUMMARY_GENERATE_LOADER,
    payload: val,
  };
}
export const setPopularImages=(val)=>{
  return {
    type: actionTypes.SET_TRIVIA_POPULAR_IMAGES,
    payload: val,
  };
}
export const setPopularGifs=(val)=>{
  return {
    type: actionTypes.SET_TRIVIA_POPULAR_GIFS,
    payload: val,
  };
}
export const setPopularVideos=(val)=>{
  return {
    type: actionTypes.SET_TRIVIA_POPULAR_VIDEOS,
    payload: val,
  };
}
